import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureToggle } from '~/platform/utilities/feature-toggles/useFeatureToggle';
import {
  ACCREDITATION_21A_INTRO_URL,
  SUBMISSIONS_PATH,
  SUBMIT_FORMS_PATH,
} from '../../utilities/constants';
import { InProgressAlert } from './Accreditation21aAlerts';

const Authorized = ({ hasInProgressForm = false }) => {
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const isSubmissionsUpdateEnabled = useToggleValue(
    TOGGLE_NAMES.accreditedRepresentativePortalCdUpdateMain,
  );

  return (
    <>
      <h1 className="dashboard__header">Dashboard</h1>
      <p className="dashboard__intro va-introtext">
        Welcome to the Accredited Representative Portal! Explore our current
        features to find claimants, establish representation and submit forms.{' '}
      </p>

      {hasInProgressForm && (
        <InProgressAlert href={ACCREDITATION_21A_INTRO_URL} />
      )}

      <ul className="dashboard__list">
        <li>
          <va-card icon-name="search">
            <va-link
              class="dashboard__card-link"
              href="/representative/find-claimant"
              text="Find claimants you represent"
            />
          </va-card>
        </li>
        <li>
          <va-card icon-name="how_to_reg">
            <va-link
              class="dashboard__card-link"
              href="/representative/representation-requests"
              text="Review representation requests"
            />
          </va-card>
        </li>
        <li>
          <va-card icon-name="assignment_turned_in">
            {isSubmissionsUpdateEnabled ? (
              <va-link
                class="dashboard__card-link"
                href={SUBMIT_FORMS_PATH}
                text="Submit forms"
              />
            ) : (
              <va-link
                class="dashboard__card-link"
                href={SUBMISSIONS_PATH}
                text="Submit forms"
              />
            )}
          </va-card>
        </li>
      </ul>

      <h2 className="dashboard__header">Are you new to the portal?</h2>
      <p>
        Learn more about using the portal features, resolving common issues, and
        contacting us if you need additional support.
      </p>
      <va-link href="/representative/help" text="Learn more about the portal" />
    </>
  );
};

Authorized.propTypes = {
  hasInProgressForm: PropTypes.bool,
};

export default Authorized;
